import {
  Button,
  Box,
  Container,
  List,
  ListItem,
  TextField,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Email, Lock } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import React, { ChangeEventHandler, FormEventHandler, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { setToken } from "../redux/reducers/auth";
import { useLoginMutation } from "../apis/auth";
import LogoIcon from "../components/LogoIcon";

const Login = () => {
  const navigate = useNavigate();
  const { token } = useAppSelector((state) => state.auth);
  const [values, setValues] = useState({ email: "", password: "" });
  const { email, password } = values;
  const dispatch = useAppDispatch();
  const [login, { isLoading, isError }] = useLoginMutation();

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();

    try {
      const response = await login(values).unwrap();
      if (!response) throw new Error();
      dispatch(setToken(response.token));
    } catch (error: any) {
      if (error.status === 401) {
        navigate("/verify", { state: { email } });
      }
    }
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (token) {
      navigate("/clients");
    }
  }, [token, navigate]);

  return (
    <Container maxWidth="sm">
      <Paper sx={{ p: 2 }}>
        <Box textAlign="center" pb={2}>
          <IconButton onClick={() => navigate("/")}>
            <LogoIcon color="primary" sx={{ fontSize: "8rem" }} />
          </IconButton>
          <Typography variant="h5">Login to your account</Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <List>
            <ListItem>
              <TextField
                label="Email Address"
                name="email"
                type="email"
                value={email}
                onChange={handleChange}
                fullWidth
                disabled={isLoading}
                required
                error={isError}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email />
                    </InputAdornment>
                  ),
                }}
              />
            </ListItem>
            <ListItem>
              <TextField
                label="Password"
                name="password"
                type="password"
                value={password}
                onChange={handleChange}
                fullWidth
                disabled={isLoading}
                required
                error={isError}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock />
                    </InputAdornment>
                  ),
                }}
              />
            </ListItem>
            <ListItem>
              <Button type="submit" fullWidth variant="contained" size="large" disabled={isLoading}>
                Log in
              </Button>
            </ListItem>
            <ListItem>
              <Button
                type="submit"
                fullWidth
                size="large"
                onClick={() => navigate("/signup")}
                disabled={isLoading}
              >
                Sign up
              </Button>
            </ListItem>
          </List>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;
